import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { ScriptsContext } from "../App";
import buildIcon from "../assets/builder_icon.svg";

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-height: 80px;
  height: auto;
  border: 1px solid ${(props) => (props.isFailed ? "#da524d" : "#6285ff")};
  background-color: ${(props) => (props.isFailed ? "#ffebeb" : "transparent")};
  border-radius: 4px;
  margin-bottom: 15px;
`;

const RowContainerJustifyStart = styled.div`
  height: 50%;
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
`;
export const RowContainerJustifyCenter = styled(RowContainerJustifyStart)`
  justify-content: center;
`;

const IconContainerCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-left: 10px;
  background-color: #f6f8fc;
`;

const IconImg = styled.img`
  display: flex;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
`;

const ScriptInformationText = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #3b4c66;
  margin-left: 10px;
`;

export const PercentageInformationText = styled(ScriptInformationText)`
  font-size: 11px;
  font-weight: 500;
`;

export const DisplayText = styled(PercentageInformationText)`
  font-size: 12px;
`;

export const ProgressBarContainer = styled.div`
  width: 70%;
  height: 10px;
  border-radius: 5px;
  background-color: #f6f8fc;
  overflow: hidden;
  margin-bottom: 20px;
  margin-top: 20px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background-color: ${(props) => (props.isFailed ? "#da524d" : "#6285ff")};
  width: ${(props) => `${props.progress}%`};
  transition: width 0.3s ease;
`;

const FAILED_STATUS = "failed";

export const LoaderContainer = () => {
  const { scriptsContext } = useContext(ScriptsContext);
  useEffect(() => {}, [scriptsContext]);

  const updateStepOrStatus = () => {
    const isUpdateStatus =
      scriptsContext.status === "completed" ||
      scriptsContext.status === FAILED_STATUS;
    const returnedStepOrStatus = isUpdateStatus
      ? scriptsContext.status
      : `${scriptsContext.scriptRunningCurrentStep}` || "error";

    return returnedStepOrStatus;
  };

  const stepOrStatus = updateStepOrStatus();

  function extractErrorMessage(errorString) {
    // Remove "Http Error: " prefix
    let errorDataStr = errorString.replace("Http Error: ", "").trim();

    // Convert single quotes to double quotes for valid JSON
    errorDataStr = errorDataStr.replace(/'/g, '"');

    // Fix incorrectly formatted "status" field
    errorDataStr = errorDataStr.replace(
      /"status":\s*"([^"]+)"/,
      (_, p1) => `"status": "${p1.replace(/"/g, "")}"`
    );

    try {
      // Parse the JSON string safely
      const dataList = JSON.parse(errorDataStr);

      // Ensure it's an array and has at least one object with a "message" key
      if (
        Array.isArray(dataList) &&
        dataList.length > 0 &&
        typeof dataList[0] === "object" &&
        "message" in dataList[0]
      ) {
        return `File failed due to error: ${dataList[0].message}`;
      } else {
        return errorString;
      }
    } catch (error) {
      return errorString;
    }
  }

  return (
    <MainContainer isFailed={stepOrStatus === FAILED_STATUS}>
      <RowContainerJustifyStart>
        <IconContainerCircle>
          <IconImg src={buildIcon} alt="builder icon" />
        </IconContainerCircle>
        <ScriptInformationText>
          {scriptsContext.scriptRunningName
            ? `${scriptsContext.numberInQueue}/${scriptsContext.queueLength} ${scriptsContext.action} ${scriptsContext.scriptRunningName}`
            : "No script running"}
        </ScriptInformationText>
        <PercentageInformationText style={{ marginTop: "5px" }}>
          {stepOrStatus + "..."}
        </PercentageInformationText>
      </RowContainerJustifyStart>
      <RowContainerJustifyCenter>
        <ProgressBarContainer>
          <ProgressFill
            isFailed={stepOrStatus === FAILED_STATUS}
            progress={scriptsContext.scriptRunningProgress * 100 || 0}
          />
        </ProgressBarContainer>
        <PercentageInformationText>{`${
          Math.round(scriptsContext.scriptRunningProgress * 100) || 0
        }%`}</PercentageInformationText>
      </RowContainerJustifyCenter>
      {scriptsContext.status === FAILED_STATUS && (
        <RowContainerJustifyCenter>
          <DisplayText>
            {extractErrorMessage(scriptsContext.message)}
          </DisplayText>
        </RowContainerJustifyCenter>
      )}
    </MainContainer>
  );
};
